var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 24,
    viewBox: "0 0 3 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H2V0.5C2 0.897825 1.84196 1.27936 1.56066 1.56066C1.27936 1.84196 0.897825 2 0.5 2H0V6H0.5C0.897825 6 1.27936 6.15804 1.56066 6.43934C1.84196 6.72064 2 7.10218 2 7.5V8.5C2 8.89782 1.84196 9.27936 1.56066 9.56066C1.27936 9.84196 0.897825 10 0.5 10H0V14H0.5C0.897825 14 1.27936 14.158 1.56066 14.4393C1.84196 14.7206 2 15.1022 2 15.5V16.5C2 16.8978 1.84196 17.2794 1.56066 17.5607C1.27936 17.842 0.897825 18 0.5 18H0V22H0.5C0.897825 22 1.27936 22.158 1.56066 22.4393C1.84196 22.7206 2 23.1022 2 23.5V24H3",
    fill: "#FD6C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherLeft);
export default __webpack_public_path__ + "static/media/voucher-left.404c3dc62c6f53fd0416932c7cd0afa2.svg";
export { ForwardRef as ReactComponent };